// API Configuration
// رابط الباك اند - رابط البرودكشن
export const API_BASE_URL = 'https://api-case-management.tawfig.info/api';
// رابط الباك اند - رابط المحلي للاختبار
// export const API_BASE_URL = 'http://localhost:8000/api';

export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH_TOKEN: '/auth/refresh',
  
  // Users
  USERS: '/users',
  USER_BY_ID: (id) => `/users/${id}`,
  
  // Cases
  CASES: '/cases',
  CASE_BY_ID: (id) => `/cases/${id}`,
  
  // Samples
  SAMPLES: '/samples',
  SAMPLES_BY_CASE: (caseId) => `/cases/${caseId}/samples`,
  SAMPLE_BY_ID: (id) => `/samples/${id}`,
  
  // Traces
  TRACES: '/traces',
  TRACES_BY_SAMPLE: (sampleId) => `/samples/${sampleId}/traces`,
  TRACE_BY_ID: (id) => `/traces/${id}`,
  
  // Static Data
  REGIONS: '/static/regions',
  CITIES: '/static/cities',
};

// Get token from localStorage
export const getToken = () => {
  return localStorage.getItem('auth_token');
};

// Set token in localStorage
export const setToken = (token) => {
  localStorage.setItem('auth_token', token);
};

// Remove token from localStorage
export const removeToken = () => {
  localStorage.removeItem('auth_token');
};

// Get refresh token from localStorage
export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};

// Set refresh token in localStorage
export const setRefreshToken = (token) => {
  localStorage.setItem('refresh_token', token);
};

// Remove refresh token from localStorage
export const removeRefreshToken = () => {
  localStorage.removeItem('refresh_token');
};
